<!--
@name 博士教育-健康管理博士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容  -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">项目简介</div>
        <div class="selector-indent">
          法国布雷斯特高等商学院健康管理博士项目，旨在整合全球政、商、医、学各界资源，为学员打造国际化学习交流与合作平台。该项目汇聚以北京大学为主的国内重点学府、权威智库与大健康专家学者、优秀导师，致力于培养具有全球化视野，强烈的社会责任感，厚重的人文情怀，睿智的创新精神，卓越的领导才能的新时代医疗健康管理复合型高级人才。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">学位全球认可</p>
          <p>学位受法国高等教育部权威认证，全球认可。商学院得到中国国家教育部“教育涉外监管网”公布认可。
          </p>
          <p class="advantage-title">名师大家云集</p>
          <p>
            云集国内外政要和名师大家，研讨国际前沿新知，把握世界发展格局，了解经济新政策、产业新趋势，树立全球视野，解决发展难题。</p>
          <p class="advantage-title">严谨的课程体系</p>
          <p>
            遵循国际商学院协会(AACSB)标准设置课程，引入全球前沿性创新型教学
            体系，采用“产、教、研、学”一体化的培养方式，培养医疗健康产业发展人才。</p>
          <p class="advantage-title">中外联合培养</p>
          <p>
            国内一流大学师资及业内专家强强联合，近距离汲取知名教授和企业家
            管理新知，做到理论和实践融会贯通、知行合一。
          </p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养特色</div>
        <div>
          <img src="@/assets/images/personRain/dgm01.png" alt="" class="course-img"/>
        </div>
      </div>
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程设计</div>
        <img src="@/assets/images/personRain/dgm01-course.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/dgm02-course.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/dgm03-course.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">师资阵容</div>
        <p>让一皮埃尔.拉法兰：法国前总理。</p>
        <p>戈登.布朗：英国前首相。</p>
        <p>毛群安：健康中国行动推进委员会办公室副主任、国家卫生健康委规划司司长。</p>
        <p>董四平：教授博士生导师、国家卫生健康委医院管理研究所、医疗政策部主任国家自然科学基金评审专家。</p>
        <p>周黎安：北京大学光华管理学院副院长、现任第十四届全国政协委员。</p>
        <p>董志勇：教授博士生导师，北京大学党委常委、副校长，第八届国务院学科评议组成员。</p>
        <p>董关鹏：教授博士生导师，中国传媒大学，国家公共关系与战略传播研究院院长。</p>
        <p>邓子梁：教授博士生导师，中国人民大学商学院副院长，国家社会科学基金重大项目首席专家。</p>
        <p>
          武国城：空军航空医学研究所研究员，全军心理卫生专家咨询和指导委员会副主任，中国心理卫生协会第七届理事会名誉理事长。</p>
        <p>胡佩诚：教授博士生导师，北京大学医学部原医学心理学教研室主任，享受国务院特殊津贴。</p>
        <p>崔界峰：北京市中西医结合精神医学研究所科研中心主任，中国中医促进会精神卫生专业委员会常委。</p>
        <p>樊富珉：教授博士生导师，心理咨询与心理治疗专业委员会副主任委员，国际行为发展研究学会会员。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 学习安排 -->
      <div class="cont-item">
        <div class="advantage">
          <div class="title-image">学习安排</div>
          <p class="advantage-title">项目学制</p>
          <p>
            3年，其中1.5年必修课程，0.5年选修课程，1年时间及论文写作与答辩。学分必
            须修满60学分，才能参加毕业论文答辩。
          </p>
          <p class="advantage-title">上课形式</p>
          <p>课堂面授学习为主，每月集中授课2天，辅以现场教学、案例分析、小组讨论等。</p>
          <p class="advantage-title">上课地点</p>
          <p>北京为教学总部，上海、广州、深圳等国内重点城市移动课堂。</p>
        </div>
      </div>
      <!-- 学习安排 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>硕士研究生及同等学力，三年以上职业经历；</p>
        <p>非硕士研究生以上学历有相关研究成果及特殊专业研究工作背景者面洽。</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.申请表（中英文）各一份</p>
          <p class="apply-text">2.个人履历（中英文）各一份</p>
          <p class="apply-text">3.最高学历证书原件或复印件及英文翻译件</p>
          <p class="apply-text">4.认证过的毕业证复印件或学信网认证报告</p>
          <p class="apply-text">5.身份证复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片4张和电子版</p>
          <p class="apply-text">7.名片4张</p>
          <p class="apply-text">8.中文推荐信1封</p>
          <p class="apply-text">9.就职公司简介（中文即可)一份</p>
        </div>
        <!--申请材料-->
        <!-- 培养方式 -->
        <div class="cont-item">
          <div class="title-image">录取机制</div>
          <p>实行“面试+推荐”双模式入学制。综合考量申请者的基本素质、教育背景、工作经验、研习能力、战略远见等，择优录取。</p>
        </div>
        <!-- 培养方式 -->
        <!-- 学费标准 -->
        <div class="cont-item">
          <div class="title-image">学费标准</div>
          <p>含注册费、授课费、教学管理费、学位证书费等费用。</p>
          <p>上课期间交通、食宿及国内外参访游学等费用自理。</p>
        </div>
        <!-- 学费标准 -->
        <!-- 报名咨询 -->
        <div class="cont-item">
          <div class="title-image">报名咨询</div>
          <p>邱老师 18600655972 ； 张老师 17701207193 ； 陈老师13611097764</p>
        </div>
        <!-- 报名咨询 -->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">健康管理博士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容  -->
    <!-- 相关资料下载 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'HealthDba',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3B/BB/wKgCEmbrmTmAWyqTAHAU6Httqfs867.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/healthDba.vue